// icon:file-copy-line | Remix Icon https://remixicon.com/ | Remix Design
import * as React from "react";
import { IconProps } from 'types/icon'

const Copy: React.FC<IconProps> = ({
    size = '16',
    color = 'currentColor',
    ...attributes
}) => {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            width={size}
            height={size}
            {...attributes}
        >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M7 6V3a1 1 0 011-1h12a1 1 0 011 1v14a1 1 0 01-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 013 21l.003-14c0-.552.45-1 1.007-1H7zM5.003 8L5 20h10V8H5.003zM9 6h8v10h2V4H9v2z" />
        </svg>
    );
}

export default Copy;
